module.exports = __webpack_public_path__ + "1cc3025553536a9fc48b0d4b4fb1a755.svg";